import { render } from "./ParticipantBlock.vue?vue&type=template&id=58b27586"
import script from "./ParticipantBlock.vue?vue&type=script&lang=ts"
export * from "./ParticipantBlock.vue?vue&type=script&lang=ts"
script.render = render

export default script